import { Link } from "react-router-dom";
import { routes } from "../../../../router/routes";
import styles from "./NewFooter.module.scss";

import BigLogo from "./bigLogo.svg";
import OkLogo from "./ok.svg";
import MaxLogo from "./max.svg";
import VkLogo from "./vk.svg";
import TgLogo from "./tg.svg";

import PhoneIcon from "./phoneIcon.svg";

import { columns } from "./items";

const NewFooter = () => {
  return (
    <div className={styles.newFooter}>
      <div className={styles.wrap}>
        <div className={styles.container}>
          <img
            src={BigLogo}
            alt="Saby"
            className={styles.logo}
            onClick={() => (window.location.href = routes.homePage)}
          />

          {/* columns  */}
          <div className={styles.columns}>
            {columns.map((column, index) => (
              <div className={styles.column}>
                <div className={styles.columnTitle}>{column.title}</div>

                <div className={styles.columnItems} id={index.toString()}>
                  {column.columnItems.map((item, index) => (
                    <Link to={item.link} className={styles.columnItem}>
                      {item.name}
                      <br />
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* addresses  */}
          <div className={styles.wrapper}>
            <div className={styles.addresses}>
              <p className={styles.address}>
                г. Уфа, ул. Менделеева 219, ул. Революционная 173
              </p>
              <p className={styles.address}>
                г. Санкт-Петербург, ул. Заневский проспект 7/7
              </p>
              <p className={styles.address}>
                г. Екатеринбург, ул. Мамина-Сибиряка 40
              </p>
              <p className={styles.address}>г. Казань, ул. Баумана, д. 82</p>
            </div>

            <div className={styles.socials}>
              <div className={styles.icons}>
                <img src={OkLogo} alt="Одноклассники" className={styles.icon} />
                <img src={MaxLogo} alt="Макс" className={styles.icon} />
                <img src={VkLogo} alt="Вконтакте" className={styles.icon} />
                <img src={TgLogo} alt="Телеграм" className={styles.icon} />
              </div>

              <div className={styles.callBtn}>
                <img src={PhoneIcon} alt="phone" className={styles.icon} />
                <a href="tel:79061006010" className={styles.text}>
                  +7 906 100-60-10
                </a>
              </div>
            </div>
          </div>

          <p className={styles.remark}>
            © "СБИС | ЦЕНТР ВНЕДРЕНИЯ". Администрация Сайта не несет
            ответственности за размещаемые Пользователями материалы (в т.ч.
            информацию и изображения), их содержание и качество.
          </p>

          <p className={styles.saby}>© сбис | центр развития 2010-2026 гг.</p>
        </div>
      </div>
    </div>
  );
};

export default NewFooter;
